import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import { LoadingSpinner } from "@tokenterminal/core/ui/progress/LoadingSpinner"
import { lazy, Suspense } from "react"
import { type RouterOutputs } from "utils/trpc"

const LazyBusinessModelSvg = lazy(() =>
  import("../AboutTab/BusinessModel").then((module) => ({
    default: module.BusinessModelSvg,
  }))
)

const LazyOnChainSources = lazy(() =>
  import("../AboutTab/OnChainSources").then((module) => ({
    default: module.OnChainSources,
  }))
)

type Props = {
  data: RouterOutputs["projects"]["getProject"]
}

const OverviewModalContent = ({ data }: Props) => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-col gap-8">
          {[
            {
              title: `What is ${data.name}?`,
              description: data.description_what,
            },
            {
              title: `How does ${data.name} work?`,
              description: data.description_how,
            },
            {
              title: `Who governs ${data.name}?`,
              description: data.description_who,
            },
          ].map((item) => {
            return (
              <div key={item.title} className="flex flex-col gap-2">
                <div className="text-sm font-medium">{item.title}</div>
                <div className="text-sm text-neutral-500">
                  {item.description}
                </div>
              </div>
            )
          })}
        </div>
        <Card className="rounded-2xl mt-4 min-h-[400px] flex items-center justify-center flex-1 p-6 relative bg-neutral-900/[0.01] dark:bg-neutral-100/[0.01]">
          <Suspense fallback={null}>
            {data.business_model.protocol_label ? (
              <LazyBusinessModelSvg
                project={{
                  id: data.api_id,
                  name: data.name,
                  logo: data.logo,
                  slug: data.slug,
                }}
                businessModel={data.business_model}
              />
            ) : (
              <div className="text-center">
                <div>No business model data available</div>
              </div>
            )}
          </Suspense>
          <div className="text-xs text-fg-secondary absolute left-4 bottom-4">
            The values in this graphic are examples and do not reflect actual
            values. Treat them as approximations.
          </div>
        </Card>
      </div>
      {data.notion_one_pager_page_id && (
        <Suspense
          fallback={
            <div>
              <Heading level={2} className="mb-4">
                On-chain sources
              </Heading>
              <Card className="flex items-center justify-center min-h-[400px]">
                <LoadingSpinner diameter={24} />
              </Card>
            </div>
          }
        >
          <div>
            <Heading level={2} className="mb-4">
              On-chain sources
            </Heading>
            <LazyOnChainSources notionId={data.notion_one_pager_page_id} />
          </div>
        </Suspense>
      )}
    </div>
  )
}

export default OverviewModalContent
